
export { PasteIcon } from "./Paste"